import React, { memo } from 'react';
import styled from 'styled-components';
import { Button, Flex, getPaletteColor, Label, Relative, Text, Tooltip } from 'pcln-design-system';
import { Calendar, Warning } from 'pcln-icons';
const DateFieldButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "DateField__DateFieldButton",
  componentId: "sc-rhwjg9-0"
})(["", " &&&{", "}&:not(:disabled){background-color:", ";}&&&:focus{", "}"], props => props.preventLabelWrap ? `overflow: hidden;
  text-wrap: nowrap;` : '', props => props.borderColor ? `border-color: ${getPaletteColor(props.borderColor)(props)}` : '', getPaletteColor('background.lightest'), props => props.borderColor ? `
        box-shadow: 0 0 0 2px ${getPaletteColor(props.borderColor)(props)};
        border-color: ${getPaletteColor(props.borderColor)(props)};
      ` : '');
function DateField({
  ariaDescription,
  borderColor,
  className,
  disabled,
  dateTextColor,
  error,
  height,
  hideTooltip = false,
  iconColor,
  isMobile = false,
  label,
  name,
  noDateLabel,
  preventLabelWrap,
  value,
  zIndex,
  onBlur,
  onClick,
  onFocus,
  ...props
}) {
  const buttonHeight = height ? height : isMobile ? 46 : 56;
  const showError = !!error;
  const showErrorTooltip = showError && !hideTooltip;
  return React.createElement(Relative, {
    className: className,
    zIndex: zIndex,
    ...props
  }, React.createElement(DateFieldButton, {
    disabled: disabled,
    variation: 'input',
    borderRadius: 'lg',
    py: 0,
    px: 2,
    height: buttonHeight,
    borderColor: borderColor || showError ? 'error.base' : undefined,
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    "data-testid": 'date-field-input',
    value: value,
    name: name,
    preventLabelWrap: preventLabelWrap,
    "aria-description": ariaDescription || `${value ? 'Change' : 'Select'} travel dates`
  }, React.createElement(Flex, {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center'
  }, React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Calendar, {
    mr: 2,
    color: disabled ? 'text.light' : iconColor ?? 'primary.base'
  }), React.createElement(Flex, {
    flexDirection: 'column'
  }, value && React.createElement(Label, {
    as: 'div',
    mb: 0
  }, label), !value && noDateLabel && React.createElement(Label, {
    as: 'div',
    mb: 0
  }, noDateLabel), !value && React.createElement(Text, {
    color: 'text.light',
    fontSize: [2, null, null, 1]
  }, label), value && React.createElement(Text, {
    color: dateTextColor,
    fontSize: [2, null, null, 1]
  }, value))), showError && React.createElement(Warning, {
    title: 'warning',
    color: 'error',
    size: 24
  }))), showErrorTooltip && React.createElement(Tooltip, {
    bottom: true,
    right: true,
    color: 'error',
    zIndex: 2
  }, error));
}
export default memo(DateField);